export const environment = {
    // deploymentType:'Dev',
    
    // assetsPath: 'assets',
    // imgPathUrl:'https://localhost:44330/api/',
    // apiUrl: 'https://localhost:44330/api/'

// deploymentType:'Beta',
    assetsPath: 'assets',
   // apiUrl: 'http://10.248.24.12/PowermateAPI/api/',
    apiUrl: 'https://dev.api.conedrive.com/ConeTools/PowermateAPI/api/',
  //apiUrl: 'https://localhost:7225/api/',
    //imgPathUrl:'https://localhost:7225/api/',
    imgPathUrl:'https://dev.api.conedrive.com/ConeTools/',
    apimSubscriptionKey: '0940246c2640494b89d733bfe2afbc21'

   
    // deploymentType:'production',
    // assetsPath: 'assets',
    // apiUrl: 'https://conetools.com/PowermateAPI/api/',
    // imgPathUrl:'https://conetools.com/'
  };